var overwritten = false;
/**
 * Overwrite `jQuery(fn)` as they can not be triggered by our script blocker.
 *
 * @see https://api.jquery.com/ready/
 */

function applyJQueryInitiator(doc) {
  // Only overwrite once
  if (overwritten) {
    return;
  }

  var _ref = doc.defaultView || doc.parentWindow,
      jQuery = _ref.jQuery;

  if (!jQuery) {
    return;
  }

  var originalFn = jQuery.fn.ready;

  jQuery.fn.ready = function (fn) {
    fn && setTimeout(function () {
      fn(jQuery);
    }, 0);
    return originalFn(function () {// Silence is golden.
    });
  };

  overwritten = true;
}

export { applyJQueryInitiator };